export var ErrorReason = /*#__PURE__*/ function(ErrorReason) {
    ErrorReason["Fetch"] = "Fetch";
    ErrorReason["EmptyResult"] = "EmptyResult";
    ErrorReason["ParsingFreewheelVmapResponse"] = "ParsingXml";
    ErrorReason["Undetermined"] = "Undetermined";
    ErrorReason["FreewheelRequest"] = "FreewheelRequest";
    ErrorReason["EmptyFreewheelVmapResponse"] = "EmptyFreewheelVmapResponse";
    ErrorReason["PreparingAdverts"] = "PreparingAdverts";
    ErrorReason["DRM"] = "DRM";
    ErrorReason["HDCP"] = "HDCP";
    ErrorReason["Embargo"] = "Embargo";
    ErrorReason["VizioUnrecoverablePipelineErrorDecode"] = "VIZIO_UNRECOVERABLE_PIPELINE_ERROR_DECODE";
    return ErrorReason;
}({});
/**
 * @public
 */ export var ErrorSeverity = /*#__PURE__*/ function(ErrorSeverity) {
    ErrorSeverity["Fatal"] = "fatal";
    ErrorSeverity["Warning"] = "warning";
    return ErrorSeverity;
}({});
export var AddonErrorCategory = /*#__PURE__*/ function(AddonErrorCategory) {
    AddonErrorCategory["CsaiAdRequest"] = "CsaiAdBreaks";
    return AddonErrorCategory;
}({});
export var SessionErrorCategory = /*#__PURE__*/ function(SessionErrorCategory) {
    SessionErrorCategory["SessionStart"] = "SessionStart";
    return SessionErrorCategory;
}({});
export var PlayerErrorCategory = /*#__PURE__*/ function(PlayerErrorCategory) {
    PlayerErrorCategory["VSF"] = "VideoStartFailure";
    PlayerErrorCategory["VPF"] = "VideoPlaybackFailure";
    return PlayerErrorCategory;
}({});

//# sourceMappingURL=error.enums.js.map